import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const STORAGE_KEY = 'adminAppLanguage';

/**
 * i18next configuration for Admin-App
 *
 * Features:
 * - Default language: German (de)
 * - Fallback language: English (en)
 * - Language detection via browser and localStorage
 * - Lazy loading of translation files via HTTP backend
 * - Feature-based namespace structure
 */
i18n
  // Load translations using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    lng: localStorage.getItem(STORAGE_KEY) || 'de',

    // Fallback language
    fallbackLng: 'en',

    // Supported languages
    supportedLngs: ['de', 'en'],

    // Default namespace
    defaultNS: 'common',

    // Namespaces to load
    ns: ['common', 'auth', 'reviews', 'settings', 'events', 'users'],

    // Backend options for lazy loading
    backend: {
      // Path to translation files. The `v` param busts the browser/CDN cache
      // on every deploy (22.09.2026-Follow-up) — public/locales/*.json is
      // served under a fixed, unhashed URL, unlike the hashed JS/CSS bundles,
      // so without this a stale cached copy could outlive the deploy that
      // changed it until the cache's own TTL expires.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__BUILD_TIME__}`,
    },

    // Language detection options
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator'],

      // Cache user language
      caches: ['localStorage'],

      // localStorage key
      lookupLocalStorage: STORAGE_KEY,
    },

    // Interpolation options
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },

    // React options
    react: {
      // Use Suspense for async loading
      useSuspense: true,
    },

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,
  });

export default i18n;
export { STORAGE_KEY };
